import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';
import { RatesFilters } from '../models/rate.types';

export const useRates = (filters: RatesFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new RatesApiAdapter(httpClient);

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['rates', filters],
    queryFn: ({ pageParam = 1 }) =>
      adapter.getRatesPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData,
  });

  const rates = data?.pages.flatMap((page) => page.rates) ?? [];
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    rates,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    totalPages: data?.pages.length ?? 0,
    totalRates: rates.length,
    total: totalFromApi,
  };
};
